import GridViewOutlined from '@mui/icons-material/GridViewOutlined'
import ShowChartOutlined from '@mui/icons-material/ShowChartOutlined'
import SpeedOutlined from '@mui/icons-material/SpeedOutlined'
import ScheduleOutlined from '@mui/icons-material/ScheduleOutlined'
import FactCheckOutlined from '@mui/icons-material/FactCheckOutlined'
import ApartmentOutlined from '@mui/icons-material/ApartmentOutlined'
import TaskAltOutlined from '@mui/icons-material/TaskAltOutlined'
import ChecklistOutlined from '@mui/icons-material/ChecklistOutlined'
import FlagOutlined from '@mui/icons-material/FlagOutlined'
import EventOutlined from '@mui/icons-material/EventOutlined'
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined'
import HourglassBottomOutlined from '@mui/icons-material/HourglassBottomOutlined'
import PersonSearchOutlined from '@mui/icons-material/PersonSearchOutlined'
import PendingActionsOutlined from '@mui/icons-material/PendingActionsOutlined'
import CompareArrowsOutlined from '@mui/icons-material/CompareArrowsOutlined'
import TimelineOutlined from '@mui/icons-material/TimelineOutlined'
import DonutSmallOutlined from '@mui/icons-material/DonutSmallOutlined'
import GroupsOutlined from '@mui/icons-material/GroupsOutlined'
import EmojiEventsOutlined from '@mui/icons-material/EmojiEventsOutlined'
import BuildOutlined from '@mui/icons-material/BuildOutlined'
import ReportGmailerrorredOutlined from '@mui/icons-material/ReportGmailerrorredOutlined'
import ReportProblemOutlined from '@mui/icons-material/ReportProblemOutlined'
import PlaylistAddCheckOutlined from '@mui/icons-material/PlaylistAddCheckOutlined'
import HandshakeOutlined from '@mui/icons-material/HandshakeOutlined'
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined'
import InsertDriveFileOutlined from '@mui/icons-material/InsertDriveFileOutlined'
import EventNoteOutlined from '@mui/icons-material/EventNoteOutlined'
import InsightsOutlined from '@mui/icons-material/InsightsOutlined'
import WidgetsOutlined from '@mui/icons-material/WidgetsOutlined'

const C = {
  compliance: { fg: '#4f46e5', bg: '#eef2ff' },
  tasks:      { fg: '#33becc', bg: '#eff4ff' },
  people:     { fg: '#0d9488', bg: '#ecfdf8' },
  response:   { fg: '#b45309', bg: '#fdf3e7' },
  estate:     { fg: '#475569', bg: '#f1f5f9' },
  docs:       { fg: '#64748b', bg: '#f3f5f8' },
}

export const WIDGET_VISUALS = {
  compliance_matrix:   { Icon: GridViewOutlined, ...C.compliance },
  compliance_trend:    { Icon: ShowChartOutlined, ...C.compliance },
  compliance_gauge:    { Icon: SpeedOutlined, ...C.compliance },
  ontime_gauge:        { Icon: ScheduleOutlined, ...C.tasks },
  obligations_status:  { Icon: FactCheckOutlined, ...C.compliance },
  buildings_rag:       { Icon: ApartmentOutlined, ...C.compliance },
  task_completion:     { Icon: TaskAltOutlined, ...C.tasks },
  tasks_overview:      { Icon: ChecklistOutlined, ...C.tasks },
  tasks_by_priority:   { Icon: FlagOutlined, ...C.tasks },
  due_this_week:       { Icon: EventOutlined, ...C.tasks },
  most_overdue:        { Icon: WarningAmberOutlined, ...C.tasks },
  overdue_ageing:      { Icon: HourglassBottomOutlined, ...C.tasks },
  unassigned_tasks:    { Icon: PersonSearchOutlined, ...C.tasks },
  awaiting_approval:   { Icon: PendingActionsOutlined, ...C.tasks },
  period_delta:        { Icon: CompareArrowsOutlined, ...C.tasks },
  ontime_trend:        { Icon: TimelineOutlined, ...C.tasks },
  domain_activity:     { Icon: DonutSmallOutlined, ...C.tasks },
  people_overview:     { Icon: GroupsOutlined, ...C.people },
  top_performers:      { Icon: EmojiEventsOutlined, ...C.people },
  actions_overview:    { Icon: BuildOutlined, ...C.response },
  incidents_overview:  { Icon: ReportGmailerrorredOutlined, ...C.response },
  remedials_severity:  { Icon: BuildOutlined, ...C.response },
  incidents_severity:  { Icon: ReportProblemOutlined, ...C.response },
  buildings_at_risk:   { Icon: ApartmentOutlined, ...C.estate },
  missing_obligations: { Icon: PlaylistAddCheckOutlined, ...C.estate },
  contractors:         { Icon: HandshakeOutlined, ...C.estate },
  permits:             { Icon: DescriptionOutlined, ...C.estate },
  recent_documents:    { Icon: InsertDriveFileOutlined, ...C.docs },
  upcoming_events:     { Icon: EventNoteOutlined, ...C.docs },
  ops_insights:        { Icon: InsightsOutlined, ...C.tasks },
  _default:            { Icon: WidgetsOutlined, fg: '#64748b', bg: '#f1f3f7' },
}

export const widgetVisual = key => WIDGET_VISUALS[key] || WIDGET_VISUALS._default
